import React from "react";

import { string, bool } from "prop-types";

const DateError = ({ errorMessage, id = "", isRed = false }) => (
  <div
    id={id}
    className="col-md-12"
    style={{
      position: "relative",
      fontSize: 12,
      color: `${isRed ? "red" : "inherit"}`,
    }}
  >
    {errorMessage}
  </div>
);

DateError.propTypes = {
  id: string,
  errorMessage: string.isRequired,
  isRed: bool,
};

export default DateError;
